import React, {FC} from 'react';
import {UseFormClearErrors, UseFormRegister, UseFormSetError, UseFormSetValue, UseFormWatch} from 'react-hook-form';
import HLFormInput from '../../shared/components/input/HLFormInput';
import HLErrorMessage from '../../shared/components/error-message/HLErrorMessage';
import HLIconButton from '../../shared/components/icon-button/HLIconButton';
import CloseIcon from '../../shared/styles/icons/CloseIcon';
import PlusIcon from '../../shared/styles/icons/PlusIcon';
import classes from './Selector.module.scss';
import {getCurrentDateTime} from "../../shared/utils/dateUtils";

interface LessonDateSelectorProps {
    register: UseFormRegister<any>;
    setError: UseFormSetError<any>;
    clearErrors: UseFormClearErrors<any>;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<any>;
    errors: any;
}

const LessonDateSelector: FC<LessonDateSelectorProps> = (
    {
        register,
        setError,
        clearErrors,
        setValue,
        watch,
        errors
    }) => {

    register('lessonDates', {
        validate: value => {
            if (!value || value.length === 0) return 'Должен быть хотя бы один урок';
        }
    });

    const selectedLessonDates: string[] = watch('lessonDates');

    const addNewLesson = () => {
        addLessonDate(getCurrentDateTime(), selectedLessonDates?.length ?? 0)
    }

    const addLessonDate = (lessonDate: string, index: number) => {
        if (!selectedLessonDates) {
            setValue('lessonDates', [lessonDate]);
        } else if (!selectedLessonDates.find((selectedLessonDate: string) => selectedLessonDate === lessonDate)) {
            let newSelectedLessonDates = [...selectedLessonDates];
            newSelectedLessonDates[index] = lessonDate
            setValue('lessonDates', newSelectedLessonDates);
        }

        clearErrors('lessonDates');
    };

    const deleteLessonDate = (lessonDate: string) => {
        if (!selectedLessonDates) {
            return;
        }

        setValue('lessonDates', selectedLessonDates.filter((selectedLessonDate) => selectedLessonDate !== lessonDate));
        if (selectedLessonDates.length <= 1) {
            setError('lessonDates', {type: 'required', message: 'Должен быть хотя бы один урок'});
        }
    };

    return (
        <>
            <div className="columnContainer">
                <div className="inlineContainer">
                    <h3>Уроки</h3>
                    <HLIconButton
                        type="button"
                        icon={<PlusIcon/>}
                        onClick={addNewLesson}
                        aria-label="Добавить урок"
                    />
                </div>

                {selectedLessonDates && selectedLessonDates.map((selectedLessonDate: string, index: number) => (
                    <div key={index} className="inlineContainer">
                        <div className={classes.dynamicInput}>
                            <HLFormInput
                                id={`student-${index}`}
                                placeholder="Дата урока"
                                value={selectedLessonDate}
                                type="datetime-local"
                                onChange={event => addLessonDate(event.target.value, index)}
                            />
                        </div>
                        <div className={classes.dynamicButton}>
                            <HLIconButton
                                icon={<CloseIcon/>}
                                onClick={() => deleteLessonDate(selectedLessonDate)}
                                aria-label="Удалить урок"
                            />
                        </div>
                    </div>
                ))}

                <HLErrorMessage error={errors.lessonDates?.message}/>
            </div>
        </>
    );
};

export default LessonDateSelector;